import { create } from 'zustand';

/**
 * Lets a record-detail page (customer, booking, …) publish the human-readable
 * label for the id it just loaded, so the sticky header can show "Aarav
 * Sharma" instead of the raw id `breadcrumbsFor` falls back to for any URL
 * segment it doesn't recognise (see `breadcrumbs.js`).
 *
 * Keyed by `path` rather than trusted blindly: a page's fetch resolves after
 * its effect's cleanup may already have fired (a fast back-navigation, a
 * changed `:id`), and without the path check the header would flash the
 * previous record's name over the new URL for one frame.
 */
const useBreadcrumbTitleStore = create((set) => ({
  path: '',
  label: '',
  setLabel: (path, label) => set({ path, label }),
  clear: () => set({ path: '', label: '' }),
}));

export default useBreadcrumbTitleStore;
